import { useSearchParams } from "react-router";

export const useIsSample = (): boolean => {
  const [searchParams] = useSearchParams();
  return searchParams.get("sample") === "true";
};
